/** 公告详情*/

/** !公告详情*/
export const API_GET_NOTICE_DETAILS = {
  url: 'index/notice/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};
/** !公告详情 v2*/
export const API_GET_NOTICE_DETAILS_V2 = {
  url: 'index/notice/details/v2',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 公告列表*/
export const API_GET_NOTICE_LIST = {
  url: 'index/notice/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 公告列表 v2新*/
export const API_GET_NOTICE_LIST_V2 = {
  url: 'index/notice/list/v2',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 必读公告*/
export const API_GET_NOTICE_LIST_READ_V2 = {
  url: 'index/notice/list/read/v2',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 待办事项详情*/
export const API_GET_TODO_DETAILS = {
  url: 'index/todo/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 待办事项列表*/
export const API_GET_TODO_LIST = {
  url: 'index/todo/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 结算通知详情(首页)*/
export const API_SUPPLIER_NOTIFICATION_DETAILS = {
  url: 'api/supplierNotification/loadDetail',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 结算通知列表(首页)*/
export const API_GET_SUPPLIER_NOTIFICATION = {
  url: 'api/supplierNotification/loadPage',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 结算通知详情状态(首页)*/
export const API_POST_SUPPLIER_NOTIFICATION_UPDATESTATUS = {
  url: 'api/supplierNotification/updateReadStatus',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** index/bill_day供应商账单日*/
export const API_GET_INDEX_BILL_DAY = {
  url: 'index/bill_day',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 获取联系人信息*/
export const API_POST_CONTACT_INFORMATION_OBJ = {
  url: 'contact/information/obj',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 更新联系人信息*/
export const API_POST_CONTACT_SAVE_OR_UPDATE_INFOMATION = {
  url: 'contact/save/or/update/information',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 获取行政区域 省/市/区*/
export const API_POST_CONTACT_LOAD_ALL_ADDRESS_CASCADER = {
  url: 'contact/load/all/address/cascader',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** 获取行政区域 省/市(不包含区)*/
export const API_POST_PURCHASE_NOTICE_LOAD_ALL_ADDRESS_CASCADER = {
  url: 'purchase/notice/load/all/address/cascader',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**修改密码*/

/**!系统设置*/
export const API_POST_EDIT_PWD = {
  url: 'system/settings/modify/password',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**设置默认供应商*/
export const API_POST_DEFAULT_SUPPLIER = {
  url: 'system/settings/default/supplier',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**订货通知单详情*/

/**!订货通知单  八个*/
// 上传明细凭证
export const API_POST_API_UPLOAD_VOUCHER_ADD = {
  url: 'api/upload/voucher/add',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

// 获取凭证信息
export const API_POST_API_UPLOAD_VOUCHER_PAGE = {
  url: 'api/upload/voucher/page',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

export const API_GET_ORDER_DETAILS = {
  url: 'purchase/notice/order/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订货通知单导出*/
export const API_GET_ORDER_EXPORT = {
  url: 'purchase/notice/order/export',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订货通知单列表*/
export const API_GET_ORDER_LIST = {
  url: 'purchase/notice/order/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**导出客户明细*/
export const API_GET_CUSTORM_LIST = {
  url: 'purchase/notice/order/detail/export',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**导出客户明细V2*/
export const API_GET_CUSTORM_ORDER_DETAIL_EXPORTV2 = {
  url: 'purchase/notice/order/detail/export/v2',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订货通知单打印单据*/
export const API_GET_ORDER_PRINT = {
  url: 'purchase/notice/order/print',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订货通知单打印次数*/
export const API_GET_NOTICE_ORDER_PRINT_NOTICE = {
  //!没有id值
  url: 'purchase/notice/order/print/notice',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订货通知单阅读次数*/
export const API_GET_PURCHASE_NOTICE_ORDER_READ = {
  url: 'purchase/notice/order/read',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**订货通知单发货*/
export const API_POST_SEND_GOODS = {
  url: 'purchase/notice/send/goods',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** purchase/notice/shop/details门店明细查看和打印*/
export const API_GET_PURCHASE_NOTICE_SHOP_DETAILS = {
  url: 'purchase/notice/shop/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 获取供应商主账号*/
export const API_GET_REGISTER_GET_SUPPLIER_MAIN_ACCOUNT = {
  url: 'register/get/supplier/main/account',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**退货通知单详情*/

/**!退货单 四个 已接完*/
export const API_GET_ORDER_RETURN_DETAILS = {
  url: 'return/order/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**退货单导出*/
export const API_GET_ORDER_RETURN_EXPORT = {
  url: 'return/order/export',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**退货单列表*/
export const API_GET_ORDER_RETURN_LIST = {
  url: 'return/order/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**return/order/print批量打印单据*/
export const API_GET_ORDER_RETURN_PRINT = {
  url: 'return/order/print',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**退货通知单详情*/

/** !退货通知单 五个*/
export const API_GET_ORDER_RETURN_NOTICE_DETAILS = {
  url: 'return/notice/order/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**退货通知单导出*/
export const API_GET_ORDER_RETURN_NOTICE_EXPORT = {
  url: 'return/notice/order/export',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**退货通知单列表*/
export const API_GET_ORDER_RETURN_NOTICE_LIST = {
  url: 'return/notice/order/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** return/notice/order/print批量打印单据*/
export const API_GET_ORDER_RETURN_NOTICE_PRINT = {
  url: 'return/notice/order/print',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** return/notice/order/read阅读*/
export const API_GET_ORDER_RETURN_NOTICE_READ = {
  url: 'return/notice/order/read',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** 供应商-公司模糊搜索*/
export const API_GET_COMPANY_LIST = {
  url: 'public/supplier/company/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**验收单详情*/

/**!验收单 四个*/
export const API_GET_ORDER_ACCEPT_DETAILS = {
  url: 'accept/order/details',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**验收单导出*/
export const API_GET_ORDER_ACCEPT_EXPORT = {
  url: 'accept/order/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**验收单列表*/
export const API_GET_ORDER_ACCEPT_LIST = {
  url: 'accept/order/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/** accept/order/print批量打印单据*/
export const API_GET_ORDER_ACCEPT_PRINT = {
  url: 'accept/order/print',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**出单方式*/

/**!公共服务 三个*/
export const API_GET_ORDER_MODE = {
  url: 'public/order/mode',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**要货地点*/
export const API_GET_SHOP_LIST = {
  url: '/public/shop/list/auth',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**要货地点*/
export const API_GET_SHOP_LIST_AUTH = {
  url: '/public/pre/shop/list/auth',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**要货地点*/
export const API_GET_SHOP_LIST_TWO_AUTH = {
  url: '/public/shop/list/auth',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** supplier/list超级供应商*/
export const API_GET_SUPPLIER_LIST = {
  //!已接完
  url: 'public/supplier/list',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/** /public/order/status退货通知单状态*/
export const API_GET_PUBLIC_ORDER_STATUS = {
  //!已接完
  url: 'public/order/status',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**供应商未确认-对账单原数据列表*/

/**!对账*/
export const API_GET_STETEMENT_1_LIST = {
  url: 'statementSourceBill/list',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商已确认财务未确认-供应商对账单列表*/
export const API_GET_STETEMENT_2_LIST = {
  url: 'statementAccount/sASupplierList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**财务已确认待开票-财务确认对账单列表*/
export const API_GET_STETEMENT_3_LIST = {
  url: 'statementAccount/sAFinanceList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商已开票-供应商已开票列表*/
export const API_GET_STETEMENT_4_LIST = {
  url: 'statementSourceBill/getSourceBillByOutInvoiceList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**已票核待生成付款单-已票核待生成付款单列表*/
export const API_GET_STETEMENT_5_LIST = {
  url: 'statementSourceBill/getSourceBillByWaitList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**已生成付款单待付款-已生成付款单待付款列表*/
export const API_GET_STETEMENT_6_LIST = {
  url: 'statementSourceBill/getSourceBillByWaitPaymentList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**已付款确认-已付款确认列表*/
export const API_GET_STETEMENT_7_LIST = {
  url: 'statementSourceBill/getSourceBillByPaymentList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商未确认-对账单原数据列表-导出*/
export const API_GET_STETEMENT_1_EXPORT = {
  url: 'statementSourceBill/exportStatementSource',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商已确认财务未确认-供应商对账单列表-导出*/
export const API_GET_STETEMENT_2_EXPORT = {
  url: 'statementAccount/supplierStatementAccountExport',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**财务已确认待开票-财务确认对账单列表-导出*/
export const API_GET_STETEMENT_3_EXPORT = {
  url: 'statementAccount/financeSupplierStatementAccountExport',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商已开票-供应商已开票列表-导出*/
export const API_GET_STETEMENT_4_EXPORT = {
  url: 'statementSourceBill/exportSourceBillByOutInvoiceList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**已票核待生成付款单-已票核待生成付款单列表-导出*/
export const API_GET_STETEMENT_5_EXPORT = {
  url: 'statementSourceBill/exportSourceBillByWaitList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**已生成付款单待付款-已生成付款单待付款列表-导出*/
export const API_GET_STETEMENT_6_EXPORT = {
  url: 'statementSourceBill/exportSourceBillByWaitPaymentList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**已付款确认-已付款确认列表-导出*/
export const API_GET_STETEMENT_7_EXPORT = {
  url: 'statementSourceBill/exportSourceBillByPaymentList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商发起对账*/
export const API_GET_STATEMENT_BY_SUPPLIER = {
  url: 'statementAccount/statementAccountBySupplier',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**供应商取消对账*/
export const API_GET_STATEMENT_BY_SUPPLIER_CANCEL = {
  url: 'statementAccount/statementAccountConcelFinance',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**财务确定*/
export const API_GET_STATEMENT_CONFIRM = {
  url: 'statementAccount/statementAccountConfirmFinance',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**勾票确认*/
export const API_POST_CHECKTICKET_CONFIRM = {
  url: 'checkticket/createcheckticket',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**勾票取消*/
export const API_POST_CHECKTICKET_CANCEL = {
  url: 'checkticket/cancelcheckticket',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

//获取供应商类型
export const API_POST_CHECKTICKET_VERIFY = {
  url: 'statementAccount/getSupplierClassify',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**勾票列表*/
export const API_CHECKTICKET_LOADPAGE = {
  url: 'checkticket/loadpage',
  config: {
    method: 'GET',
    host: 'CAISX_SETTLE',
  },
};

/**删除附件*/
export const API_CHECKTICKET_DELETEFILE = {
  url: 'checkticket/cancelById',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**保存附件*/
export const API_CHECKTICKET_SAVEFILE = {
  url: 'checkticket/saveBatchCheckTicketFile',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**获取附件列表*/
export const API_CHECKTICKET_FILELIST = {
  url: 'checkticket/selectByCheckTicketNo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**发票提交*/
export const API_CHECKTICKET_INVOICESUBMIT = {
  url: 'invoice/createInvoice',
  config: {
    method: 'POST',
    host: 'CAISX_SETTLE',
  },
};

/**发票暂存*/
export const API_CHECKTICKET_STORAGE = {
  url: 'invoice/addInvoice',
  config: {
    method: 'POST',
    host: 'CAISX_SETTLE',
  },
};

/**删除发票*/
export const API_CHECKTICKET_DELETEINVOICESUBMIT = {
  url: 'invoice/deleteInvoice',
  config: {
    method: 'delete',
    host: 'CAISX_SETTLE',
  },
};

/**票核通过*/
export const API_CHECKTICKET_AUDITSTATUSSUBMIT = {
  url: 'checkticket/updAuditStatusOk',
  config: {
    method: 'GET',
    host: 'CAISX_SETTLE',
  },
};

/**票核拒绝*/
export const API_CHECKTICKET_AUDITSTATUSREFUSEDSUBMIT = {
  url: 'checkticket/updAuditStatusNo',
  config: {
    method: 'GET',
    host: 'CAISX_SETTLE',
  },
};

/** 强制票核*/
export const API_CHECKTICKET_MANDATORYAUDITSTATUSSUBMIT = {
  url: 'checkticket/updAuditStatusNobb',
  config: {
    method: 'GET',
    host: 'CAISX_SETTLE',
  },
};

/**获取勾票票核状态*/
export const API_CHECKTICKET_GETAUDITSTATUS = {
  url: 'checkticket/getauditstatus',
  config: {
    method: 'GET',
    host: 'CAISX_SETTLE',
  },
};

/**获取勾票详情*/
export const API_CHECKTICKET_GETCHECKTICKETDETAIL = {
  url: 'checkticket/getcheckticketdetail',
  config: {
    method: 'GET',
    host: 'CAISX_SETTLE',
  },
};

/**票核管理-税率下拉选择*/
export const API_GET_INVOICE_GETTAXALL = {
  url: 'invoice/getTaxAll',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取发票列表*/
export const API_GET_INVOICELIST = {
  url: 'reportsInvoiceCheck/reportsInvoiceCheckPage',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取发票导出*/
export const API_GET_INVOICE_EXPORT = {
  url: 'reportsInvoiceCheck/reportsInvoiceCheckExport',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取公司下拉*/
export const API_GET_COMPANYCODE_LIST = {
  url: 'statementSourceBill/getCompanyCodeAndName',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**电子签章图片上传功能*/
export const API_POST_UPLOAD = {
  url: 'signData/upload',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**获取授权模块*/
export const API_GET_SIGNMOBILE_MODULE = {
  url: 'signMobile/module',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取所有供应商*/
export const API_GET_ALL_SUPPLIER = {
  url: 'signMobile/allSupplier',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取供应商税号、机构名称*/
export const API_GET_TAXCODEORGNAME = {
  url: 'getTaxCodeOrgName',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取原手机验证码*/
export const API_GET_SENDCODE_TA = {
  url: 'signMobile/sendVerificationCode',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取现在手机验证码*/
export const API_GET_SENDCODE_ME = {
  url: 'signMobile/sendPersonThreeFactor',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**手机变更查询列表*/
export const API_GET_SIGNMOBILE_LIST = {
  url: 'signMobile',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**手机变更查询 详情*/
export const API_GET_SIGNMOBILE_DETAIL = {
  url: 'signMobile/{id}',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**签章数据列表*/
export const API_GET_SIGNMDATA_LIST = {
  url: 'signData/list',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**签章数据列表-详情*/
export const API_GET_SIGNMDATA_DETAILS = {
  url: 'signData/signDataInfo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**已签章的对账单列表*/
export const API_GET_STATEMENTACCOUNTSIGN = {
  url: 'statementaccountsign/loadPage',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**已签章的对账单  下载*/
export const API_GET_STATEMENTACCOUNTSIGN_DOWNLOAD = {
  url: 'statementaccountsign/download',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**已签章的对账单  自动签章*/
export const API_GET_STATEMENTACCOUNTSIGN_SIGN = {
  url: 'statementaccountsign/sign',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**打印对账单*/
export const API_GET_PRINT_STATEMENT = {
  url: 'statementAccount/printStatementAccount/',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取原手机号码*/
export const API_GET_TA_PHONE = {
  url: 'signMobile/getOriginaMobile',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**校验云签手机验证码-有原手机*/
export const API_GET_PHONE_CODE_STATUS = {
  url: 'signMobile/checkVerificationCodeHasOriginaMobile',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**校验云签手机验证码-无原手机*/
export const API_GET_PHONE_CODE_STATUS_ONE = {
  url: 'signMobile/checkVerificationCodeNoOriginaMobile',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**创建OR变更签章电话*/
export const API_POST_SIGNMOBILE_CREAT = {
  url: 'signMobile/registerOrUpdate',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**申请云签手机发送验证码*/
export const API_POST_SENDCODE_SIGNDATA = {
  url: 'signData/sendMobileCode',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**申请云签提交申请*/
export const API_POST_SIGNDATA_CREAT = {
  url: 'signData/create',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**申请云签变更申请*/
export const API_POST_SIGNDATA_CHANGE = {
  url: 'signData/update',
  config: {
    method: 'put',
    host: 'CAISX_SETTLE',
  },
};

/**申请电子签章生成或者更新*/
export const API_POST_SIGNDATA_CHANGEORUPDATE_BASIE = {
  url: 'signData/uploadSupplierBasieSignData',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**申请电子签章生成或者更新*/
export const API_POST_SIGNDATA_CHANGEORUPDATE_CREDENTIALS = {
  url: 'signData/uploadSupplierCredentialsSignData',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**申请云签获取云签申请详情*/
export const API_GET_DATAINFO_BY_TAXCODE = {
  url: 'signData/signDataInfo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取省份联动数据*/
export const API_GET_PROVINCE_LIST = {
  url: 'signData/address',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**根据勾票号或者对账单号查询单据明细*/
export const API_GET_SOUTCEBILL_DETAIL = {
  url: 'statementSourceBill/getSourceBillDetail',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**对账点击签章*/
export const API_GET_STATEMENT_SIGN = {
  url: 'statementaccountsign/sign',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取枚举有无原手机号验证码*/
export const API_GET_VERIFICATIONCODEFLAG = {
  url: 'signMobile/verificationCodeFlag',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**电子签章手机号详情*/
export const API_GET_SIGNMOBILE_DETAILS = {
  url: 'signMobile',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**票核管理修改归属日期*/
export const API_GET_CHECKTICKET_UPDATETIME = {
  url: 'checkticket/updAffiliationDate',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**票核管理-发票类型下拉*/
export const API_GET_INVOICE_INVOICETRPE = {
  url: 'invoice/selectInvoiceTypeList',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**票核管理-发票校验*/
export const API_GET_INVOICE_CHECK = {
  url: 'invoice/check',
  config: {
    method: 'put',
    host: 'CAISX_SETTLE',
  },
};

/**对账管理-是否显示签章按钮*/
export const API_GET_ISSHOWSIGN_BYSUPPLIER = {
  url: 'signData/isShowSign',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**未付款金额 导出*/
export const API_EXPORT_UMBNONPAYMENT = {
  url: 'unpayment/export',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**未付款金额查询列表*/
export const API_GET_LOADPAYMENTAMOUNTDETAIL = {
  url: 'unpayment/loadUnPaymentAmountDetail',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取单据类型*/
export const API_GET_BILLTYPE = {
  url: 'statementSourceBill/getbilltype',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取发生地点*/
export const API_GET_HAPPENPLACE = {
  url: 'statementSourceBill/getHappenPlace',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取付款状态*/
export const API_GET_PAYMENT_StATUS = {
  url: 'statementSourceBill/getSourceBillPaymentStatus',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
export const API_GET_PAYMENT_StATUS2 = {
  url: 'statementSourceBill/getSourceBillPaymentStatusTwo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取对账状态枚举*/
export const API_GET_STATEMENTSTATE = {
  url: 'statementSourceBill/statementState',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**单据冻结列表*/
export const API_GET_BILL_FROZEN_LIST = {
  url: 'statementSourceBill/frozenList',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**修改单据冻结状态*/
export const API_PUT_EDIT_FROZEN_STATUS = {
  url: 'statementSourceBill/updfrozenstatus',
  config: {
    method: 'put',
    host: 'CAISX_SETTLE',
  },
};

/**单据冻结列表导出*/
export const API_GET_EXPORT_FROZEN_LIST = {
  url: 'statementSourceBill/exportFrozenList',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**付款单查询列表-导出*/
export const API_EXPORT_QUERYLIST = {
  url: 'payment/paymentExport',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**付款单查询列表*/
export const API_GET_QUERYLIST = {
  url: 'payment/queryList',
  config: {
    method: 'POST',
    host: 'CAISX_SETTLE',
  },
};

/**获取采购组织群集*/
export const API_GET_PURCHASEORG = {
  url: 'purchase/getListPurchaseOrgByPurchaseOrgCodes/',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**供应商对账信息查询列表(供应商已确认财务未确认的对账信息)-导出*/
export const API_EXPORT_RECONCILIATIONINFO = {
  url: 'reportsStatementAccount/supplierStatementAccountExport',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**供应商对账信息查询列表(供应商已确认财务未确认的对账信息)*/
export const API_GET_RECONCILIATIONINFO = {
  url: 'reportsStatementAccount/supplierStatementAccountPage',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**发票导入*/
export const API_INVOICE_IMPORT = {
  url: 'invoice/importinvoicenotsave',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**对账-费用单详情-目标返利导出*/
export const API_GET_BUSINESSDETAIL_EXPORT = {
  url: 'statementSourceBill/exportAgreementSettleBusinessDetail',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**对账-费用单详情-目标返利导出*/
export const NEW_API_GET_BUSINESSDETAIL_EXPORT = {
  url: 'agreementSettleBusinessDetail/export',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**对账-费用单详情-促销扣款导出*/
export const API_GET_BILLCOSTDETAIL_EXPORT = {
  url: 'statementSourceBill/exportPromotionDeductDetail',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**对账-费用单详情-促销扣款导出*/
export const API_GET_PROMOTIONDEDUCTDETAIL_EXPORT = {
  url: 'promotionDeductDetail/export',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**对账-出入库源单据详情导出excel*/
export const API_GET_BILL_EXPORT = {
  url: 'statementSourceBill/inOutDetailExport',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**对账-源单据列表和对应明细导出excel*/
export const API_GET_SOUTCEBILL_EXPORT = {
  url: 'statementSourceBill/exportSourceBillsAndDetails',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取手机验证码  主账号手机修改*/
export const API_GET_SETTING_VERIFYCODE = {
  url: '/system/settings/get/verifyCode',
  config: {
    method: 'get',
    host: 'SUPPLIER',
  },
};

/**修改主账号手机号*/
export const API_MODIFY_SUPPLIER_NUMBER = {
  url: '/system/settings/supplier/modify',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**报表查询-供应商费用单查询*/
export const API_GET_SETTLEBILL_LIST = {
  url: 'settleBill',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**报表查询-供应商费用单查询-导出*/
export const API_GET_SETTLEBILL_EXPORT = {
  url: 'settleBill/supplierSettleBillExport',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取费用代码costCode*/
export const API_GET_COST_CODE = {
  url: 'costCode/all',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**根据勾票单号获取对应的对账单号*/
export const API_GET_STATEMENTACCOUNT_BY_CHECKTIKETNO = {
  url: 'statementAccount/getStatementAccountNoByCheckTiketNo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**获取销售数据查询列表*/
export const API_GET_SALESDATA_LIST = {
  url: 'salesData/list',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**销售数据导出*/
export const API_GET_SALESDATA_EXPORT = {
  url: 'salesData/export',
  config: {
    method: 'post',
    host: 'SUPPLIER',
  },
};

/**单据冻结列表-总计*/
export const API_GET_BILL_FROZEN_Total = {
  url: 'statementSourceBill/sourceBillStatistics',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/**发起对账检验回款*/
export const API_GET_STATEMENT_ACCOUNT_CHECK_MONEY_BACK_STATUS_BY_SUPPLIER = {
  url: 'statementAccount/checkMoneyBackStatusBySupplier',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/***
 * @param companyCodes 公司编码
 * @param statementNos 业务单号
 */
export const API_POST_PFREIGHT_STATEMENT_ACCOUNT_LIST = {
  url: 'freightStatementAccount/list',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/** 导出*/
export const API_POST_PFREIGHT_STATEMENT_FREIGHT_STATEMENT_ACCOUNT_EXPORT = {
  url: 'freightStatementAccount/freightStatementAccountExport',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

/** 修改账单状态*/
export const API_GET_FREIGHT_STATEMENT_ACCOUNT_UPDATE_PAYMENT_STATUS_BY_STATEMENT = {
  url: 'freightStatementAccount/updatePaymentStatusByStatement',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/***/
export const API_GET_FREIGHT_STATEMENT_ACCOUNT_UPDATE_REIMBURSEMENT_NO_BY_STATEMENT = {
  url: 'freightStatementAccount/updateReimbursementNoByStatement',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

/**模糊查询供应商*/
export const API_GET_SEARCHSUPPLIER = {
  url: 'supplier/getSupplierInfoByLikeSupplerCodes',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 采购单监控列表查询
export const API_GET_PURCHASEORDERMONITORING_LIST = {
  url: 'statementPurchaseDone/loadPage',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

// 采购单监控详情列表
export const API_GET_PURCHASEORDERMONITORING_DETAILSLIST = {
  url: 'statementPurchaseDone/detail',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

// 开票管理-开票申请-获取费用类型下拉
export const API_GET_INVOICEMANAGEMEN_COSTTYPE = {
  url: 'select/getCostCodeSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

// 开票管理-开票申请-获取开票申请状态下拉
export const API_GET_INVOICEMANAGEMEN_INVOICESTATUS = {
  url: 'select/getApplyStateSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

// 开票管理-开票申请-获取开票状态下拉
export const API_GET_INVOICEMANAGEMEN_INVOICETYPE = {
  url: 'select/getKpStateSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-列表查询
export const API_GET_INVOICEMANAGEMEN_LIST = {
  url: 'kpApply/settleBill',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-导出
export const API_GET_INVOICEMANAGEMEN_EXPORT = {
  url: 'kpApply/settleBill/export',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-导出
export const API_GET_INVOICEMANAGEMEN_SUBMIT = {
  url: 'kpApply/commitKpApply',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-发票抬头下拉
export const API_GET_INVOICEMANAGEMEN_INFOLIST = {
  url: 'kpApply/getInvoiceInfo',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-开票类型下拉
export const API_GET_INVOICEMANAGEMEN_INVOICETYPELIST = {
  url: 'kpApply/getKpTypes',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-开票方式下拉
export const API_GET_INVOICEMANAGEMEN_INVOICEKPTYPE = {
  url: 'kpApply/invoiceKpType/$invoiceType',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请-开户行
export const API_GET_KPAPPLYRECORD_FIHMPORRTDATA = {
  url: 'kpApply/getCompanyInvoiceBank',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请记录-列表
export const API_GET_INVOICERECORD_LIST = {
  url: 'kpApplyRecord/loadPage',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请记录-审核状态下拉
export const API_GET_INVOICERECORD_AUDIT = {
  url: 'select/getAuditStateSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请记录-发票类型下拉
export const API_GET_INVOICERECORD_INVOICETYPE = {
  url: 'select/getInvoiceTypeSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请记录-开票方式下拉
export const API_GET_INVOICERECORD_KPTYPELIST = {
  url: 'select/getInvoiceKpTypeSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请记录-导出
export const API_GET_INVOICERECORD_EXPORT = {
  url: 'kpApplyRecord/export',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票申请记录-详情
export const API_GET_INVOICERECORD_DETAILS = {
  url: 'kpApplyRecord/kpApplyDetail',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-列表
export const API_GET_BILLINGINQUIRY_LIST = {
  url: 'settleInvoice/loadPage',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-发票种类下拉
export const API_GET_BILLINGINQUIRY_INVOICETYPE = {
  url: 'select/getInvoiceGategorySelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-发票状态下拉
export const API_GET_BILLINGINQUIRY_INVOICESTATUS = {
  url: 'select/getInvoiceStateSelect',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-预览
export const API_GET_INVOICE_LOADBYID = {
  url: 'settleInvoice/loadInvoiceDetail/$id',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-预览
export const API_GET_INVOICE_LOADBYID2 = {
  url: 'settleInvoice/printInvoice/$id',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-删除
export const API_GET_BILLINGINQUIRY_DELETE = {
  url: 'settleInvoice/deleteInvoice',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-更新状态
export const API_GET_BILLINGINQUIRY_UPDATE = {
  url: 'settleInvoice/syncInvoice',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-重新发起
export const API_GET_BILLINGINQUIRY_RELOAD = {
  url: 'settleInvoice/restartRedApply',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-重新发起
export const API_GET_BILLINGINQUIRY_DRSCARD = {
  url: 'settleInvoice/cancelInvoice',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-导出
export const API_GET_BILLINGINQUIRY_EXPORT = {
  url: 'settleInvoice/export',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-上传
export const API_GET_BILLINGINQUIRY_UPLOAD = {
  url: 'settleInvoice/upload',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-开票查询-红冲
export const API_GET_BILLINGINQUIRY_HEDGE = {
  url: 'settleInvoice/hedgeInvoice',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 开票管理-发票查询-审批流列表
export const API_GET_BILLINGINQUIRY_APPROVAL = {
  url: 'approvalDetail',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};

//票核管理-纸质发票复核
export const API_GET_INVOICE_REVIEW_CHECK_PAPER = {
  url: 'invoice/ocr/reviewPaperInvoice',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
//票核管理-纸质发票复核
export const API_INVOICE_NO_LIST_REVIEW_CHECK_PAPER = {
  url: 'invoice/loadList',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
//票核管理-发票查验- 详情
export const API_GET_INVOICE_CHECK_STATUS_DET = {
  url: 'invoice/ocr/getInspectionDetail',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
//票核管理-发票复核 - 详情
export const API_GET_INVOICE_REVIEW_CHECK_STATUS_DET = {
  url: 'invoice/ocr/getReviewInspectionDetail',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
//删除发票
export const API_CHECKTICKET_DELETEINVOICESUBMIT_NEW = {
  url: 'invoice/ocr/deleteOCRInvoice',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};

// 更新经办人身份
export const API_POST_SIGNDATA_UPDATEIDENTITYTYPE = {
  url: 'signData/updateIdentityType',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
// 根据供应商主税号查询认证状态
export const API_GET_SIGNDATA_QUERYVERIFYSTATUS = {
  url: 'signData/queryVerifyStatus',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 获取法大大认证连接
export const API_GET_SIGNDATA_GETFDDVERIFYURL = {
  url: 'signData/getFddVerifyUrl',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 获取变更手机号认证连接
export const API_GET_SIGNMOBILE_GETFDDVERIFYURL  = {
  url: 'signMobile/getFddVerifyUrl',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 获取法大大授权链接
export const API_GET_SIGNMOBILE_GETFDDAUTHURL  = {
  url: 'signMobile/getFddAuthSignatureUrl',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 获取法大大合同下载地址
export const API_GET_SETTLE_STATEMENTACCOUNTSIGN_GETFDDDOWNLOADURL = {
  url: 'statementaccountsign/getFddDownloadUrl',
  config: {
    method: 'get',
    host: 'CAISX_SETTLE',
  },
};
// 
// 公司电子签章申请 导出
export const API_POST_SIGNCOMPANY_EXPORT = {
  url: 'signCompany/export',
  config: {
    method: 'post',
    host: 'CAISX_SETTLE',
  },
};
